// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import {changeWorkQueue} from "../../workQueueSlice";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import {changeContractHierarchySearchControls} from "../../Header/contractHierarchySearchControlsSlice";
import {changeContractStatsControls} from "../../WorkStats/contractStatsControlsSlice";
import {changeContractStats} from "../../WorkStats/contractStatsSlice";


// main function
export default function CardViewContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const handleCardView = () => {
        onMenuClose();
        console.log("Card View from action menu");
        dispatchData(changeWorkQueue({
            cardsState: true, actionMenuState: false
        }));
        dispatchData(changeContractHierarchySearchControls({contractHierarchySearchState: true
        }));
        // dispatchData(changeContractHierarchySearchControls({contractHierarchySearchState: true
        // }));
        dispatchData(changeWorkQueue({contractHeaderState: false
        }));
        dispatchData(changeContractStatsControls({gridDisplay: null}));
        dispatchData(changeContractStats({seriesId: null, seriesTitle: null,seasonId: null, seasonName: null, productId: null}));
    };



    return (

        <Box>
            {(
                    rowContractData.contractLevel === "Property" ||
                    rowContractData.contractLevel === "Labor Group" ||
                    rowContractData.contractLevel === "Guild" ||
                        rowContractData.contractLevel === "Option" ||
                        rowContractData.contractLevel === "Cast" ||
                        rowContractData.contractLevel === "Engagement"
                ) &&
                <MenuItem onClick={handleCardView}>
                    <ListItemIcon>
                        <ViewModuleIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Card View</ListItemText>
                </MenuItem>}
        </Box>

    )

}
